import DashboardPassportFileEditorItem from "./DashboardPassportFileEditorItem";

export default DashboardPassportFileEditorItem;
